<template>
  <div class="campaigns_filter">
    <div class="flex flex-between">
      <h5 class="campaigns_filter--label">{{ label }}</h5>

      <div class="campaigns_filter--select_all">
        <button-link
          @click="selectAll"
          class="campaigns_filter--select_all--button"
        >select all
        </button-link>
        <button-link
          @click="deselectAll"
          class="campaigns_filter--select_all--button"
        >deselect all
        </button-link>
      </div>
    </div>

    <div class="campaigns_filter--list">
      <b-checkbox
        v-for="option in options"
        :key="option.id"
        v-model="filterValue"
        :native-value="option.id"
        @input="handleInput"
        size="is-small"
      >
        {{ option.label }}
      </b-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterCampaignsMultiple",
  props: {
    label: {
      type: String,
      default: "Campaigns"
    },
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
    initialValue: Number,
  },
  created() {
    if (this.initialValue) {
      this.commitCampaigns([this.initialValue])
    }

    this.handleInput()
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].campaigns;
      },
      set(value) {
        this.commitCampaigns(value);
      }
    },
    options() {
      return [
        {id: -1, label: "No Campaign"},
        ...this.$store.getters.activeCampaigns,
      ];
    },
    text() {
      if (!this.filterValue.length) return null

      let campaignLabels = []
      this.filterValue.forEach(campaignId => {
        if (campaignId === 0) {
          campaignLabels.push("No Campaign")
        } else {
          const campaign = this.$store.getters.activeCampaigns.find(campaign => {
            return campaign.id === campaignId
          })

          if (campaign) {
            campaignLabels.push(campaign.label)
          }
        }
      })

      return campaignLabels.join(", ")
    },
  },
  methods: {
    selectAll() {
      this.filterValue = this.options.map(campaign => campaign.id)
      this.handleInput()
    },
    deselectAll() {
      this.filterValue = []
      this.handleInput()
    },
    commitCampaigns(ids) {
      this.$store.commit(this.storeModule + "/setOneFilter", [
        this.filterName,
        "campaigns",
        ids
      ])
    },
    handleInput() {
      this.$emit("change", this.text)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.campaigns_filter {

  &--label {
    font-size: 0.875rem;
    font-weight: normal;
  }

  &--select_all {
    display: flex;

    &--button {
      margin-left: 10px;
    }
  }

  &--list {
    padding: 8px 4px 0;
  }
}

::v-deep .b-checkbox.checkbox {
  display: flex !important;
  margin-bottom: 4px;
}
</style>
